import { addToChainAfter, ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import {
    RemoveCartLineApiParameter,
    removeCartLineWithResult as removeCartLineApi,
} from "@insite/client-framework/Services/CartService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, RemoveCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import { removeFromCartEvent } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        cartLineId: string;
    },
    RemoveCartLineApiParameter
>;

export const TriggerRemoveFromCartEvent: HandlerType = props => {
    const session = getSession(props.getState());
    const state = props.getState();
    const { cartId } = getQueryStrings(state);
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    let itemData = null;
    let value = 0;
    if (cart?.cartLines && cart.cartLines.length) {
        for (let i = 0; i < cart.cartLines.length; i++) {
            const line = cart.cartLines[i];
            if (line.id === props.parameter.cartLineId) {
                itemData = {
                    item_id: line.erpNumber,
                    item_name: line.shortDescription,
                    item_brand: line.brand?.name || "",
                    price: line.pricing?.actualPrice ?? 0,
                    quantity: line.qtyOrdered ?? 0,
                };
                value = (line.pricing?.actualPrice ?? 0) * (line.qtyOrdered ?? 0);
                break; // Found the item, no need to continue
            }
        }
    }

    removeFromCartEvent({
        event: "remove_from_cart",
        ecommerce: {
            currency: session?.currency?.currencyCode,
            value,
            items: itemData ? [itemData] : [],
        },
    });
};


addToChainAfter(chain, RemoveCartLine, TriggerRemoveFromCartEvent);